<template>
    <div class="bo-carousel">
        <!-- <div class="catalog" >
            <div class="catalog-header">
                <div class="title theme-primary-color">Catalog</div>
                <a href="#" class="view-all theme-primary-color">
                    View All
                    <i class="icon-chevronright"></i>
                </a>
            </div>

            <div class="catalog-list">
                <a :href="category.link" class="catalog-item" v-for="category in categories" :key="category.index">
                    <div class="image">
                         <img :src="category.img" alt="Category image" />
                    </div>

                    <div class="categories">
                        <div class="total-items">
                            {{ category.count }} Product<span v-if="category.count > 1">s</span>
                        </div>
                        <div class="name">
                            {{ category.name }}
                        </div>
                    </div>
                </a>
            </div>
        </div> -->

        <div class="carousel" ref="carousel">
            <a
                :href="image.link"
                v-for="image in images"
                :key="image.index"
            >
                <img :src="getUniqueParam(image.src)" />
            </a>
        </div>
    </div>
</template>

<script>
import "slick-carousel";

export default {
    props: {
        images: {
            type: Array,
            default: "",
        },
    },
    mounted() {
        this.$nextTick(() => {
            const $carousel = jQuery(this.$refs.carousel);
            if (!$carousel.hasClass("slick-initialized")) {
                $carousel.slick({
                    arrows: true,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                });
            }
        });
    },
    beforeDestroy() {
        try {
            const $carousel = jQuery(this.$refs.carousel);
            if ($carousel.hasClass("slick-initialized")) {
                $carousel.slick("unslick");
            }
        } catch (e) {
            console.error("Error destroying slick carousel:", e);
        }
    },
    methods: {
        getUniqueParam(src) {
            return src + `?t=${Date.now()}`;
        },
    },
};
</script>
